import AddCustomerSection from "../../StoreCheckout/AddCustomerSection";

export const CustomerSelection = ({
  customerInfo,
  setCustomerInfo,
  showAddCustomer = true,
}) => {
  return (
    <AddCustomerSection
      title="Search Existing Customers"
      customerDetails={customerInfo}
      setCustomerDetails={(customerDetails) => {
        if (customerDetails?.customerId)
          return setCustomerInfo({
            customer_id: customerDetails?.customerId,
            ...customerDetails,
          });

        setCustomerInfo(null);
      }}
      allowApiAddCustomer={true}
      showAddCustomer={showAddCustomer}
    />
  );
};
